"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.MountedModal = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _material = require("@mui/material");

var _Card = _interopRequireDefault(require("../Card"));

var _LoadingOverlay = _interopRequireDefault(require("../LoadingOverlay"));

var _IconBtnTooltip = _interopRequireDefault(require("../IconBtnTooltip"));

require("./MountedModal.style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var MountedModal = /*#__PURE__*/function (_Component) {
  _inherits(MountedModal, _Component);

  var _super = _createSuper(MountedModal);

  function MountedModal() {
    _classCallCheck(this, MountedModal);

    return _super.apply(this, arguments);
  }

  _createClass(MountedModal, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          actionButtons = _this$props.actionButtons,
          keepMounted = _this$props.keepMounted,
          hasLeftCancelBtn = _this$props.hasLeftCancelBtn,
          isLoading = _this$props.isLoading,
          width = _this$props.width,
          onCloseModal = _this$props.onCloseModal,
          open = _this$props.open,
          title = _this$props.title;

      var renderActionButtons = function renderActionButtons(actionButtons) {
        return actionButtons.map(function (button, index) {
          var variant = index === actionButtons.length - 1 ? button.buttonType || 'contained' : button.buttonType || 'text'; // default first button to 'contained' variant

          var color = button.color || 'primary'; // can override color, defaults to primary

          return /*#__PURE__*/_react["default"].createElement(_material.Button, {
            key: index,
            color: color,
            disabled: button.disabled || button.loading,
            onClick: button.action,
            variant: variant,
            style: {
              marginLeft: '10px'
            },
            type: button.type || 'button'
          }, button.label);
        });
      };

      return /*#__PURE__*/_react["default"].createElement(_material.Modal, {
        keepMounted: keepMounted,
        open: open,
        onClose: onCloseModal
      }, /*#__PURE__*/_react["default"].createElement(_Card["default"], {
        styles: {
          width: width
        },
        className: "MountedModal_outerContainer"
      }, /*#__PURE__*/_react["default"].createElement(_LoadingOverlay["default"], {
        show: isLoading,
        width: "100%",
        style: {
          textAlign: 'center'
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "MountedModal_container"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "MountedModal_title"
      }, title), /*#__PURE__*/_react["default"].createElement("div", {
        className: "MountedModal_closeBtn"
      }, /*#__PURE__*/_react["default"].createElement(_IconBtnTooltip["default"], {
        icon: "close",
        onClick: onCloseModal
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "MountedModal_horiz"
      }, /*#__PURE__*/_react["default"].createElement("hr", {
        style: {
          color: '#999'
        }
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "MountedModal_contents"
      }, children), /*#__PURE__*/_react["default"].createElement("div", {
        className: "MountedModal_cancelBtn"
      }, hasLeftCancelBtn && /*#__PURE__*/_react["default"].createElement(_material.Button, {
        onClick: onCloseModal
      }, "CANCEL")), /*#__PURE__*/_react["default"].createElement("div", {
        className: "MountedModal_actionButtons"
      }, renderActionButtons(actionButtons))))));
    }
  }]);

  return MountedModal;
}(_react.Component);

exports.MountedModal = MountedModal;

_defineProperty(MountedModal, "propTypes", {
  open: _propTypes["default"].bool.isRequired,
  title: _propTypes["default"].string.isRequired,
  onCloseModal: _propTypes["default"].func.isRequired,
  width: _propTypes["default"].oneOf(['sm', 'md', 'lg', false]),
  keepMounted: _propTypes["default"].bool,
  hasLeftCancelBtn: _propTypes["default"].bool,
  isLoading: _propTypes["default"].bool,
  actionButtons: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    action: _propTypes["default"].func.isRequired,
    label: _propTypes["default"].string.isRequired,
    buttonType: _propTypes["default"].string,
    color: _propTypes["default"].string,
    disabled: _propTypes["default"].bool,
    loading: _propTypes["default"].bool,
    type: _propTypes["default"].string
  }))
});

MountedModal.defaultProps = {
  actionButtons: [],
  hasLeftCancelBtn: false,
  isLoading: false,
  keepMounted: true,
  width: 'md'
};
var _default = MountedModal;
exports["default"] = _default;